<template>
  <div class="col-12 col-md-6 p-5 text-left">
    <router-link class="border row p-3" :to="'/human/' + data.slug">
      <div class="col-12 pb-3 text-center">
        <img :src="data.data.location_photo" :alt="data.data.name">
      </div>
      <h4 class="col-12">{{data.data.catchphrase}}</h4>
      <h3 class="col-12 border-top border-bottom">{{data.data.name}}</h3>
      <div class="col-12">
        <p class="line-container">
          <span class="d-inline-block line">{{data.data.doing}}</span>
          <span class="leader">...</span>
        </p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  }
};
</script>

<style scoped lang="scss">
img {
  width: 100%;

  /* // 中デバイス（タブレット, 768px 以上） */
  @media (min-width: 768px) {
    object-fit: cover;
    height: 153px;
  }

  /* // 大デバイス（デスクトップ, 992px 以上） */
  @media (min-width: 992px) {
    height: 233px;
  }

  /* // 特大デバイス（ワイド・デスクトップ, 1200px 以上） */
  @media (min-width: 1200px) {
    height: 293px;
  }
}

.line-container {
  position: relative;
}

.leader {
  position: absolute;
  right: 0;
  bottom: 0.4rem;
}

.line {
  white-space: pre-wrap;
  overflow: hidden;
  height: 3.6em;
  font-size: 1rem;
  line-height: 1.8;
  padding-right: 1rem;
}
</style>
